<template>
  <div>
    <input @change="setFile($event)"
           accept="application/rtf,.doc,.docx,.xml,application/msword,application/pdf,application/vnd.ms-excel"
           name="image"
           ref="inputUploadFile"
           style="font-size: 1.2em; padding: 10px 0;"
           type="file"
           v-show="false"
    />

    <v-layout
      align-center
      class="align-items-center flex-xl-nowrap flex-md-nowrap flex-xs-wrap flex-sm-wrap"
    >
      <v-flex xl3 md3 sm5 xs6 flex-column-reverse class="text-xl-left text-md-left text-sm-center text-xs-center">
        <span class="span_1">Файл {{fieldLabel}}</span>
        <span class="red--text span_2">*</span>:
      </v-flex>


      <v-flex xl3 md2 sm5 xs6 class="text-xl-center text-md-center">
        <a  v-if="value.file !==''
          && typeof value.file !== 'object'" :href="value.file" target="_blank" rel="noopener noreferrer"
        >
          Ссылка на файл
        </a>
        <div v-if="typeof value.file === 'object' && value.file !== null"> {{value.file.name}}</div>
      </v-flex>


      <v-layout justify-xl-center justify-md-center justify-sm-center justify-xs-center align-center
                class="align-items-center" v-if="template !== undefined">
        <v-flex xl10 md9 sm6 xs6 class="align-md-start">
          <span>
            <span v-for="item, i in  template">
              (<a :href="item.document" target="_blank" rel="noopener noreferrer"> Шаблон: {{item.name}} </a>)
              </br>
            </span>
          </span>
        </v-flex>

        <v-spacer v-if="this.screenSize === 'xl'"></v-spacer>

        <v-flex xl2 md4 sm6 xs6 class="text-xl-right text-md-right text-sm-center text-xs-center" column v-if="!isOnlyRead()">
          <v-btn v-if="typeof value.file === 'object'
               && value.file !== null  || typeof value.file === 'string'" color="primary" flat @click="clearFile">
            <v-icon>close</v-icon>
            Открепить
          </v-btn>
          <v-btn v-else @click="$refs.inputUploadFile.click()"
                 color="primary"
                 flat>
            <v-icon>folder_open</v-icon>
            Прикрепить
          </v-btn>
        </v-flex>
      </v-layout>

      <v-layout v-else>
        <v-flex class="text-xl-right text-md-right text-sm-center text-xs-center" column v-if="!isOnlyRead()">
          <v-btn v-if="typeof value.file === 'object'
               && value.file !== null  || typeof value.file === 'string'" color="primary" flat @click="clearFile">
            <v-icon>close</v-icon>
            Открепить
          </v-btn>
          <v-btn v-else @click="$refs.inputUploadFile.click()"
                 color="primary"
                 flat>
            <v-icon>folder_open</v-icon>
            Прикрепить
          </v-btn>
        </v-flex>
      </v-layout>
      <v-container pa-2 v-if="this.screenSize === 'xs' || this.screenSize === 'sm'"></v-container>
    </v-layout>


    <v-alert
      color="red lighten-2"
      type="warning"
      :value="error"
    >
      {{ String(error_messages) }}
    </v-alert>
  </div>

</template>

<script>

    import {isOnlyReadPermission} from "../../../helper";

    export default {
        name: "FileInput",
        props: ['file', 'fieldLabel', 'field', 'error', 'error_messages', 'template'],
        screenSize: null,
        data() {
            // console.log(this.$vuetify.breakpoint.name)
            return {
                value: {
                    file: this.$props.file || null,
                    field: this.$props.field || '',
                    screenSize: this.$vuetify.breakpoint.name,
                },
            }
        },
        watch: {

            file: {
                handler(value) {
                    this.value.file = this.$props.file
                    this.value.field = this.$props.field
                },
                deep: true,
                immediate: true,
            },
        },
        methods: {
            isOnlyRead(){
              return isOnlyReadPermission()
            },
            setFile(e) {
                const file = e.target.files[0];
                this.value.file = file;
                this.$emit('updateFile', this.value)
            },
            clearFile() {
                this.value.file = null;
                this.$emit('updateFile', this.value)
            },
            screenResize() {
              this.screenSize = this.$vuetify.breakpoint.name
            }
        },
        created() {
          window.addEventListener('resize', this.screenResize);
          this.screenResize();
        },
    }
</script>

<style scoped>
.v-alert{
  padding: 6px;
}
@media (min-width: 960px){
  @media (max-width: 1264px) {
    .flex.md3{
      flex-basis: 35%;
    }
    .flex.md2{
      flex-basis: 21%;
    }
  }
  .layout.flex-xl-nowrap, .layout.flex-md-nowrap{
    flex-wrap: nowrap;
  }
}
@media (min-width: 0) and (max-width: 600px){
  .layout.flex-xs-wrap, .layout.flex-sm-wrap{
    flex-wrap: wrap;
  }
}
</style>
